(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialIbqDeleteController',MaterialIbqDeleteController);

    MaterialIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Material'];

    function MaterialIbqDeleteController($uibModalInstance, entity, Material) {
        var vm = this;

        vm.material = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Material.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
